import React from 'react';
import { Video } from 'lucide-react';
export function TestimoniosSection() {
  return <section className="bg-[#FFFFFF] py-24 md:py-32 px-6 md:px-12 lg:px-24" data-id="element-136">
      <div className="max-w-6xl mx-auto flex flex-col items-center space-y-16" data-id="element-137">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F0F0F] text-center max-w-3xl" data-id="element-138">
          Lo que dicen quienes ya jugaron desde otro nivel
        </h2>

        {/* Video Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full" data-id="element-139">
          {[1, 2, 3, 4, 5, 6].map(item => <div key={item} className="aspect-video bg-[#0F0F0F] rounded-2xl flex items-center justify-center relative overflow-hidden group cursor-pointer" data-id="element-140">
              <div className="absolute inset-0 bg-[#0F0F0F]/40 group-hover:bg-[#0F0F0F]/20 transition-colors" data-id="element-141"></div>
              <Video className="w-12 h-12 text-[#C9A96E] relative z-10" data-id="element-142" />
            </div>)}
        </div>

        {/* Written Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full pt-8" data-id="element-143">
          {[1, 2, 3].map(item => <div key={item} className="bg-[#FFFFFF] border border-[#0F0F0F]/10 p-8 rounded-2xl flex flex-col space-y-4" data-id="element-144">
              <div className="text-[#C9A96E] text-4xl font-serif leading-none" data-id="element-145">
                "
              </div>
              <p className="text-[#0F0F0F] text-lg flex-grow" data-id="element-146">
                [Placeholder para testimonio escrito. Aquí va la experiencia de
                transformación del cliente.]
              </p>
              <p className="text-[#0F0F0F] font-bold" data-id="element-147">— Nombre del Cliente</p>
            </div>)}
        </div>
      </div>
    </section>;
}